import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register a minimal, no-cache service worker so Chromium/Edge/Android
// Chrome consider the app installable and fire `beforeinstallprompt`.
// The worker itself just passes fetches through — no caching, so it
// cannot serve stale content.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Silent — the app still works fine without an installable SW.
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
